export const typeWriterData = [
  "Healthy",
  "Safe",
  "Competitive",
  "Fun",
  "Successful",
];

export const serviceData = [
  {
    title: "Player Representation",
    phraseOne: "Player",
    phraseTwo: "Representation",
    summary:
      "We represent players in several ways. We assist professional gaming teams with scouting and help our partnered gamers join professional teams that we work with. Our team-finding program is designed to help talented gamers find the best professional team for them. We also have a program that helps our partnered gamers find high-quality sponsorships. On top of all of this, we provide students involved in the gaming community the chance to obtain several different scholarships ranging from $500 to $50,000.",
  },
  {
    title: "Team Representation",
    phraseOne: "Team",
    phraseTwo: "Representation",
    summary:
      "At FPS we make sure teams who work with us are well represented in the gaming community and we provide them with plenty of opportunities. We hold gatherings where all our teams and potential sponsors have a chance to network and make deals. Fps has a “Shoutout” program which includes a twitch and youtube page where different players from our teams will have the spotlight for the chance to grow their brand. There are monthly ethics meetings to remind teams what we stand for and how they should be conducting themselves professionally. We provide fundraising events for our teams to give back to the community.",
  },
  {
    title: "Sponsor Ship",
    phraseOne: "Sponsor Ship",
    phraseTwo: null,
    summary:
      "We are passionate and extremely dedicated to helping gamers from all walks of life turn their hobbies into careers. We provide the financial structure required to support gamers by finding them high-quality sponsorships and spots in professional teams and tournaments. Our highly trained agents work day and night to ensure that our partner gamers find the best opportunities available.",
  },
];

export const testimonialData = [
  {
    title: "Alexandra Lowenthal",
    text:
      "I’m a huge fan of all the gamers that work with this awesome company! I watch all of their streams and love their content. They all say this company is the reason they can continue to do what they do. This company is great, and I really appreciate them!",
    src: "https://source.unsplash.com/OsZh6c0NyZ8/300x300",
  },
  {
    title: "Nick Romanov",
    text:
      "As a content creator, streamer, and gamer I can say that this company has helped me through many hardships by helping me find awesome sponsorships and opportunities.",
    src: "https://source.unsplash.com/PA7gdK5fmck/300x300",
  },
  {
    title: "Nizar Albusaidy",
    text:
      "I believe in recognizing and empowering gamers to stream and continue to make content without a financial burden, and so does this company. They make the lives of my favorite streamers easier, which allows them to entertain us more.",
    src: "https://source.unsplash.com/qgd2bS_JhF4/300x300",
  },
];

export const bio = [
  {
    name: "Jared Logan",
    bio:
      "As the CEO of FPS, Jared Logan has been able to create a safe space in the gaming community where only those who have a strong code of ethics can thrive. Before he started fps he was a gamer with a love for esports and a passion for commentating. While commentating he met players in the community and heard how they were having issues making a living from competing. Jared was also able to observe the toxicity that was a problem for the community and how it could hinder the growth of the esports scene. He decided he would be the bridge between companies and esports/gamers, helping gamers with a strong code of ethics find sponsors as well as help other players find and form teams.",
    title: "Chief executive Officer",
  },
  {
    name: "Brandon Rorie",
    bio:
      "Hello! My name is Brandon and I’m the chief financial advisor of this company. I’m responsible for managing the financial actions of the company and oversee the process of setting up sponsorships for gamers contracted with us. My job and passion are to help gamers financially so they can continue to provide great content!",
    title: "Chief financial Officer",
  },
  {
    name: "Muhammad Rajput",
    bio:
      "Muhammad graduated from UNCC in 2012 with degree in Human Relations. In 2015, he was hired by FPS as HR. Through the years, he rose to the top through his hard work. As the Head of Human Resources Muhammad is tasked with making sure every Employee at FPS adheres to the Code of Conduct",
    title: "Head of Human Resources",
  },
];

export const codeOfEthics = [
  {
    title: "Ethics",
    text: [
      "No discrimination based on gender, race, sexuality, religion, and politics.",
      "Personal information is secure and protected through trust.",
      "Freedom to express your thoughts in a respectful manner that does not offend or target people based on gender, race, sexuality, and religion.",
    ],
    panel: "panel1",
  },
  {
    title: "Serving our partners",
    text: [
      "We go out of our way to ensure that gamers get the best possible deal when working with us. We do not take advantage of our partners and allow them to opt-out whenever they wantwithout penalty.",
      "Gamers and content creators value Fair Play Scouts because we deliver high-quality services and hold ourselves to the highest standard in how we treat our partners. We treat all of our partners equally and with respect.",
    ],
    panel: "panel2",
  },
  {
    title: "Partner Expectations",
    text: [
      "Our partnered gamers are required to adhere to our code of ethics and treat each other with respect.",
    ],
    panel: "panel3",
  },
];

export const community = [
  {
    title: "Method Community Center",
    date: "September 8, 2014",
    bio:
      "Method Community Center provides a place for everyone to have fun, hold events, and come closer as community",
    url: "https://source.unsplash.com/Gh9JA1jasCo/1600X1600",
  },
  {
    title: "Optimus Community Center",
    date: "July 8, 2016",
    bio:
      "Optimus Community Center provides state-of-art training facility for future eSports games",
    url: "https://source.unsplash.com/QdAAasrZhdk/1600X1600",
  },
];
